import { Box, styled, keyframes } from '@mui/material';

const scanlineScrollAnimation = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 0 100%; }
`;

const crtFlickerAnimation = keyframes`
  0% { opacity: 1; }
  3% { opacity: 0.93; }
  6% { opacity: 1; }
  9% { opacity: 0.94; }
  12% { opacity: 1; }
  50% { opacity: 1; }
  100% { opacity: 0.98; }
`;

const CrtOverlayRoot = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  zIndex: 100,

  /* CRT flicker effect */
  animation: `${crtFlickerAnimation} 6s infinite`,

  willChange: 'opacity, transform',

  /* Scanline effect (more visible with alternating darker line) */
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'repeating-linear-gradient(0deg, rgba(255,255,255,0.08) 0px, rgba(255,255,255,0.08) 1px, rgba(0,0,0,0.04) 1px, rgba(0,0,0,0.04) 2px, transparent 2px, transparent 5px)',
    backgroundSize: '100% 6px',
    animation: `${scanlineScrollAnimation} 6s linear infinite`,
    mixBlendMode: 'soft-light',
    opacity: 0.32,
    pointerEvents: 'none',
  },

  /* Smooth vignette + gentle color bloom using a blurred radial gradient */
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'radial-gradient(ellipse at center, rgba(125,211,199,0.10) 0%, rgba(125,211,199,0.04) 20%, rgba(0,0,0,0.45) 100%)',
    filter: 'blur(28px)',
    opacity: 0.85,
    pointerEvents: 'none',
    mixBlendMode: 'screen',
  },

  /* reduce heavy inner shadows to avoid strong banding */
  boxShadow: `inset 0 0 36px rgba(125,211,199,0.03)`,
}));

export function CrtOverlay() {
  return <CrtOverlayRoot />;
}
